import React from 'react';
import { useParams } from 'react-router-dom';
import useDeployedGlobalRules from 'Hooks/query-hooks/global-rules/useDeployedGlobalRules';
import useDeployedMerchantRules from 'Hooks/query-hooks/single-merchant/useDeployedMerchantRules';
import useGetListNames from 'Hooks/query-hooks/list/useGetListNames';
import useGetParameters from 'Hooks/query-hooks/parameters/useGetParameters';
import RouteLoading from 'Components/RouteLoading';
import errorController from 'Components/ErrorScreens';
import appStyles from 'Routes/Routes.css';
import MerchantDeployedTable from './components/MerchantDeployedTable';
import MerchantDeployedOverview from './components/MerchantDeployedOverview';
import Header from './components/Header';

const MerchantDeployed = () => {
    const { mid } = useParams<{ mid: string }>();
    const listNamesAPI = useGetListNames();
    const parametersAPI = useGetParameters({
        queryParams: {
            status: JSON.stringify(['active'])
        }
    });
    const deployedGlobalRulesAPI = useDeployedGlobalRules({
        enabled:
            !listNamesAPI.isFetching &&
            !listNamesAPI.isLoading &&
            !parametersAPI.isFetching &&
            !parametersAPI.isLoading,
        listNameMap: listNamesAPI.data,
        parameterData: parametersAPI.data
    });
    const deployedMerchantRulesAPI = useDeployedMerchantRules({
        merchantId: mid,
        enabled:
            !listNamesAPI.isFetching &&
            !listNamesAPI.isLoading &&
            !parametersAPI.isFetching &&
            !parametersAPI.isLoading,
        listNameMap: listNamesAPI.data,
        parameterData: parametersAPI.data
    });
    const { hasError, errorCmp } = errorController([deployedGlobalRulesAPI.error, deployedMerchantRulesAPI.error]);

    if (
        deployedGlobalRulesAPI.isLoading ||
        deployedGlobalRulesAPI.isFetching ||
        deployedMerchantRulesAPI.isLoading ||
        deployedMerchantRulesAPI.isFetching
    ) {
        return <RouteLoading />;
    }

    if (hasError) return errorCmp;

    return (
        <div className={appStyles.landingPage}>
            <Header />
            <MerchantDeployedOverview merchantRules={deployedMerchantRulesAPI.data as MerchantRulesData} />
            <MerchantDeployedTable
                merchantId={mid}
                globalRules={deployedGlobalRulesAPI.data!}
                merchantRules={deployedMerchantRulesAPI.data!}
            />
        </div>
    );
};

export default MerchantDeployed;
